<template>
  <div class="forgot-password">
    <div class="forgot-password-title mb-3">Forgot Password</div>
    <div
      v-show="error"
      class="error mt-3 mb-6 text-red-600"
      data-test="error-message"
    >
      {{ error }}
    </div>
    <div
      v-show="success"
      class="success mt-3 mb-6 text-green-600"
      data-test="success-message"
    >
      <div>Password reset successfully.</div>
      <Button
        class="p-button"
        @click="loginRedirect"
        data-test="login-button"
      >
        Log In
      </Button>
    </div>
    <div
      v-if="!success"
      class="flex flex-col"
    >
      <label
        for="new-password"
        class="poppins"
        >New Password *</label
      >
      <InputText
        id="new-password"
        class="p-inputtext-lg w-288 mb-1"
        v-model="newPassword"
        type="password"
        :class="{ 'p-invalid': passwordAlert }"
        data-test="new-password"
      />
      <small
        v-if="passwordAlert"
        class="p-error mb-4"
        >{{ passwordAlertText }}</small
      >

      <label
        for="confirm-password"
        class="poppins"
        >Confirm New Password *</label
      >
      <InputText
        id="confirm-password"
        class="p-inputtext-lg w-288"
        v-model="newPasswordConfirm"
        type="password"
        @blur="confirmBlurred = true"
        data-test="confirm-password"
      />
    </div>
    <Button
      v-if="!success"
      class="p-button mt-6"
      :disabled="passwordAlert || !newPassword || newPassword !== newPasswordConfirm || processing || success"
      @click="resetPassword"
      data-test="confirm-button"
    >
      Confirm
    </Button>
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue';
import { useAuthStore } from '@/stores/AuthStore.js';
import { useRoute } from 'vue-router';
import Modal from '@/components/Modal.vue';

const authStore = useAuthStore();
const route = useRoute();
const confirmBlurred = ref(false);
const error = ref(null);
const key = ref(null);
const newPassword = ref('');
const newPasswordConfirm = ref('');
const processing = ref(false);
const success = ref(false);

const passwordAlert = computed(() => {
  return (
    confirmBlurred.value &&
    newPassword.value &&
    newPasswordConfirm.value &&
    newPassword.value !== newPasswordConfirm.value
  );
});

const passwordAlertText = computed(() => {
  return passwordAlert.value ? 'Passwords do not match' : null;
});

onMounted(() => {
  key.value = route.query.key;
});

function resetPassword() {
  if (newPassword.value != newPasswordConfirm.value) {
    return;
  }

  processing.value = true;
  authStore
    .resetPassword(key.value, newPassword.value)
    .then((response) => {
      if (response && response.data?.success) {
        success.value = true;
      } else {
        if (response.data?.message) {
          error.value = response.data.message;
        } else {
          error.value = 'An error occurred. Please try again.';
        }
      }
    })
    .catch(() => {
      error.value = 'An error occurred. Please try again.';
    })
    .finally(() => {
      processing.value = false;
    });
}

function loginRedirect() {
  authStore.redirectToTokenAuth();
}
</script>
<style scoped>
.forgot-password {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
}
.forgot-password-title {
  font-size: 1.85rem;
  font-weight: bold;
}
</style>
